/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { businessMemoriesListContentScopes } from "../funcs/businessMemoriesListContentScopes.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListBusinessMemoryContentScopesResponseBody } from "../models/components/listbusinessmemorycontentscopesresponsebody.js";
import {
  ListBusinessMemoryContentScopesRequest,
  ListBusinessMemoryContentScopesSecurity,
} from "../models/operations/listbusinessmemorycontentscopes.js";
import { unwrapAsync } from "../types/fp.js";
export type ListBusinessMemoryContentScopesQueryData =
  ListBusinessMemoryContentScopesResponseBody;

export function prefetchListBusinessMemoryContentScopes(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListBusinessMemoryContentScopesRequest | undefined,
  security?: ListBusinessMemoryContentScopesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListBusinessMemoryContentScopesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListBusinessMemoryContentScopesQuery(
  client$: GramCore,
  request?: ListBusinessMemoryContentScopesRequest | undefined,
  security?: ListBusinessMemoryContentScopesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListBusinessMemoryContentScopesQueryData>;
} {
  return {
    queryKey: queryKeyListBusinessMemoryContentScopes({
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function listBusinessMemoryContentScopesQueryFn(
      ctx,
    ): Promise<ListBusinessMemoryContentScopesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(businessMemoriesListContentScopes(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListBusinessMemoryContentScopes(
  parameters: {
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "businessMemories", "listContentScopes", parameters];
}
